export default __webpack_public_path__ + "img/d6a0ffb9940ba9887054c653855cb4f7.svg";